import { Plus, TrendingUp } from "lucide-react-native";
import { Text, View } from "react-native";
import { SectionTitle } from "@louise/moon-ui";
import { EMBER, GLASS_CARD_STYLE } from "@louise/moon-ui/theme/tokens";
import { useTranslations } from "@src/packages/i18n";
import { CarePillActionButton } from "@src/packages/homepage/plan/components/CarePillActionButton";

export default function MonitoringEmptyStateCard({
  title,
  showSectionTitle = true,
  onAddData,
  marginTop = 24,
}: {
  title?: string;
  showSectionTitle?: boolean;
  onAddData?: () => void;
  marginTop?: number;
}) {
  const t = useTranslations();
  const resolvedTitle = title ?? t("care.response_chart.default_title");

  return (
    <View style={{ marginTop }}>
      {showSectionTitle ? (
        <View
          className="flex-row"
          style={{
            alignItems: "center",
            gap: 8,
            marginBottom: 10,
            paddingHorizontal: 2,
            flexWrap: "wrap",
          }}
        >
          <SectionTitle icon={TrendingUp}>{resolvedTitle}</SectionTitle>
        </View>
      ) : null}

      <View
        style={{
          ...GLASS_CARD_STYLE,
          paddingHorizontal: 12,
          paddingTop: 12,
          paddingBottom: 12,
        }}
      >
        <View
          style={{
            paddingTop: 12,
            paddingBottom: 4,
            alignItems: "center",
            gap: 10,
          }}
        >
          <TrendingUp
            size={26}
            color={EMBER.colors.textLight}
            strokeWidth={1.6}
          />
          <Text
            className="font-dm-sans"
            style={{
              fontSize: 14,
              fontWeight: "700",
              color: EMBER.colors.text,
              textAlign: "center",
            }}
          >
            {t("care.response_chart.empty_title")}
          </Text>
          <Text
            className="font-dm-sans"
            style={{
              fontSize: 12,
              color: EMBER.colors.textLight,
              textAlign: "center",
              maxWidth: 260,
              lineHeight: 16,
            }}
          >
            {t("care.response_chart.empty_subtitle")}
          </Text>
          {onAddData ? (
            <View style={{ flexDirection: "row", marginTop: 4 }}>
              <CarePillActionButton
                label={t("care.response_chart.add_data_button")}
                onPress={onAddData}
                icon={Plus}
                variant="secondary"
                flexGrow={0}
                flexBasis={184}
              />
            </View>
          ) : null}
        </View>
      </View>
    </View>
  );
}
